<template>
  <div id="costs">
    <v-container class="overflow-y-auto">
      <v-stepper v-model="step">
        <v-stepper-header>
          <template
            class="stepper-headers"
            v-for="(costSection, index) in costSections"
          >
            <v-stepper-step 
              :key="`step-${index}`"
              :step="index + 1"
              color="blue lighten-1"
              :complete="costSection.completed"
              @click="updateStep(index + 1)"
            >
              {{ costSection.name }}
            </v-stepper-step>
            <v-divider :key="`divider-${index}`" v-if="index !== 4"></v-divider>
          </template>
        </v-stepper-header>

        <v-stepper-items v-for="(costSection, index) in costSections" :key="index">
          <CostSection
            :index="index"
            @update-total="updateTotal"
            @update-step="updateStep"
            @update-complete-status="complete.prevention = true"
            @return-to-previous-cost-section="decreaseStep"
            @verify-cost-section="verifyCostSection"
          />
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </div>
</template>

<script>
import CostSection from "@/components/Calculator/CostSection.vue";
import GeneralService from "@/services/GeneralService";

export default {
  name: "calculator",
  components: {
    CostSection,
  },
  props: {
    thePage: {
      type: Number,
      default: 2,
    },
  },
  data: () => ({
    step: 1,
    total: null,
  }),
  computed: {
    activeStep() {
      return Number(this.$route.query.activeStep);
    },
    costSections() {
      return this.$store.state.costSections;
    },
  },
  watch: {
    activeStep: {
      immediate: true,
      handler(val) {
        if (val) {
          this.step = val;
        }
      },
    },
    step: {
      handler() {
        GeneralService.scrollTop();
      },
    },
    thePage: {
      immediate: true,
      handler(val) {
        this.$emit('update:page', val);
      },
    },
  },
  methods: {
    decreaseStep() {
      this.step--;
    },
    updateStep(step) {
      this.verifyCostSection(this.step);
      this.step = step;
    },
    updateTotal(total) {
      this.total = total;
    },
    verifyCostSection(step) {
      this.total > 0
        ? this.costSections[step - 1].completed = true
        : this.costSections[step - 1].completed = false;
    }
  },
  created: function() {
    GeneralService.scrollTop();
  },
};
</script>

<style lang="scss">
.v-stepper__step {
  cursor: pointer;
}
</style>